export default __webpack_public_path__ + "static/media/checked.90d5a2f0.png";